import script from "./StatsSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatsSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./StatsSidebar.vue?vue&type=style&index=0&id=50052b2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50052b2a"]])

export default __exports__